import './custom-elements/assemblies/index.js';
import './custom-elements/ballyhoo/index.js';
import './custom-elements/base/index.js';
import './custom-elements/document/index.js';
import './custom-elements/gadgets/index.js';
import './custom-elements/gidgets/index.js';